/**
 * training-groups.js
 */

import React from 'react';
import { useMediaQuery } from '@mui/material';
import { makeLocation } from 'utils/routing';
import TrainingGroupsMobile from './training-groups-mobile';
import TrainingGroupsDesktop from './training-groups-desktop';
import TrainingGroupsDrawer from './training-groups-drawer';


export const trainingPath = 'training';


export const trainingGroupsRoute = (history) => {
  return makeLocation('', 'groups', 'typeMenu', { type: trainingPath }, history?.location);
}


export const trainingGroupRoute = (id, history) => {
  return makeLocation('', 'groups', 'trainingGroup', { id }, history?.location);
}


export const newTrainingGroup = (user, activeDogs) => {
  const members = user.role.isHandler ? [{ ...user, activeDogCount: activeDogs.length, isLeader: true }] : [];
  const membership = user.role.isHandler ? { isLeader: true } : null;
  return {
    id: 0,
    name: 'New Group',
    members,
    membership
  };
}


export const canLeaveGroup = (group, user) => {
  return group?.members
    ?.filter(m => m.isLeader)
    .map(m => m.id)
    .join() !== `${user.id}`;
}


export default function TrainingGroups(props) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <>
      {isMobile && <TrainingGroupsMobile />}
      {!isMobile && <TrainingGroupsDesktop />}
      <TrainingGroupsDrawer />
    </>
  )
}